import { render, staticRenderFns } from "./frm_create_super.vue?vue&type=template&id=08114705&"
import script from "./frm_create_super.vue?vue&type=script&lang=js&"
export * from "./frm_create_super.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports